var _clipPath, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _path, _g17, _path2, _g18, _path3, _g19, _g20, _g21, _g22, _g23, _clipPath2, _clipPath3, _radialGradient, _radialGradient2, _linearGradient, _mask, _g24, _radialGradient3, _mask2, _radialGradient4, _clipPath4, _radialGradient5, _radialGradient6, _linearGradient2, _mask3, _g25, _radialGradient7, _mask4, _radialGradient8, _clipPath5, _radialGradient9, _radialGradient0, _linearGradient3, _mask5, _g26, _g27, _g28, _path4, _g29, _g30, _g31, _path5, _g32, _g33, _g34, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1200 1200",
    width: 1200,
    height: 1200,
    preserveAspectRatio: "xMinYMin slice",
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0px, 0px, 0px)",
      contentVisibility: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 1200,
    x: 0,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "__lottie_element_3"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_4)",
    transform: "matrix(1,0,0,1,79,79)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9636568427085876,-0.14445558190345764,0.14445558190345764,0.9636568427085876,520.9869995117188,520.9979858398438)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 3,
    d: " M-172.86300659179688,285.2130126953125 C-159.5330047607422,281.3399963378906 -145.1909942626953,275.87200927734375 -129.9669952392578,268.8169860839844 C5.968999862670898,205.8699951171875 175.27000427246094,34.46099853515625 247.4149932861328,-113.26899719238281 C284.37701416015625,-188.9720001220703 290.17498779296875,-248.11099243164062 263.3070068359375,-275.5329895019531 C239.38999938964844,-299.95001220703125 192.03199768066406,-297.56500244140625 129.9669952392578,-268.82598876953125 C-5.968999862670898,-205.87899780273438 -175.27000427246094,-34.470001220703125 -247.4149932861328,113.26000213623047 C-284.37701416015625,188.96299743652344 -290.17498779296875,248.1020050048828 -263.3070068359375,275.52398681640625 C-263.3070068359375,275.52398681640625 -263.3070068359375,275.52398681640625 -263.3070068359375,275.52398681640625 C-252.3699951171875,286.697998046875 -236.531005859375,292.2590026855469 -216.6199951171875,292.2590026855469 C-203.67599487304688,292.2590026855469 -189.01300048828125,289.906005859375 -172.86300659179688,285.2130126953125"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9659205675125122,-0.1376165747642517,0.1376165747642517,0.9659205675125122,520.9910278320312,520.9940185546875)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 3,
    d: " M-190.58099365234375,290.8179931640625 C-178.7729949951172,287.9200134277344 -166.1719970703125,283.8599853515625 -152.86199951171875,278.63800048828125 C-11.958000183105469,223.3459930419922 171.62600708007812,53.79499816894531 256.3689880371094,-99.3239974975586 C301.2900085449219,-180.49600219726562 311.35699462890625,-244.95799255371094 283.9750061035156,-276.20098876953125 C261.322998046875,-302.05499267578125 214.7550048828125,-302.92498779296875 152.86199951171875,-278.6390075683594 C11.958000183105469,-223.3470001220703 -171.62600708007812,-53.79600143432617 -256.3689880371094,99.322998046875 C-301.2900085449219,180.4949951171875 -311.35699462890625,244.95700073242188 -283.9750061035156,276.20001220703125 C-283.9750061035156,276.20001220703125 -283.9750061035156,276.20001220703125 -283.9750061035156,276.20001220703125 C-272.27398681640625,289.56201171875 -254.19500732421875,296.2430114746094 -230.9239959716797,296.2430114746094 C-218.822998046875,296.2430114746094 -205.32000732421875,294.43499755859375 -190.58099365234375,290.8179931640625"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9684562683105469,-0.12974406778812408,0.12974406778812408,0.9684562683105469,521.0009765625,521.0040283203125)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 3,
    d: " M-208.7899932861328,295.52899169921875 C-198.61099243164062,293.52301025390625 -187.84300231933594,290.71099853515625 -176.53599548339844,287.0870056152344 C-31.336000442504883,240.5709991455078 166.3209991455078,74.38200378417969 264.0830078125,-83.38899993896484 C317.635009765625,-169.79200744628906 332.4330139160156,-239.71099853515625 304.72100830078125,-275.1969909667969 C283.3869934082031,-302.51300048828125 237.86000061035156,-306.7430114746094 176.5330047607422,-287.09600830078125 C31.33300018310547,-240.5800018310547 -166.32400512695312,-74.38999938964844 -264.08599853515625,83.38099670410156 C-317.625,169.78399658203125 -332.4360046386719,239.70199584960938 -304.7239990234375,275.18798828125 C-304.7239990234375,275.18798828125 -304.7239990234375,275.18798828125 -304.7239990234375,275.18798828125 C-292.218994140625,291.197998046875 -271.4259948730469,299.2760009765625 -244.01699829101562,299.2760009765625 C-233.25999450683594,299.2760009765625 -221.48399353027344,298.0299987792969 -208.7899932861328,295.52899169921875"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9712294936180115,-0.12085728347301483,0.12085728347301483,0.9712294936180115,521.0059814453125,520.9929809570312)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 3,
    d: " M-227.64700317382812,299.35101318359375 C-219.15199279785156,298.09600830078125 -210.21499633789062,296.31500244140625 -200.85299682617188,294.00299072265625 C-52.1349983215332,257.3970031738281 159.25399780273438,96.16100311279297 270.3900146484375,-65.40499877929688 C333.1789855957031,-156.68299865722656 353.2349853515625,-232.11000061035156 325.4309997558594,-272.3399963378906 C305.1910095214844,-301.60699462890625 262.114013671875,-309.10400390625 200.85299682617188,-294.0159912109375 C52.1349983215332,-257.3970031738281 -159.2530059814453,-96.16100311279297 -270.3890075683594,65.40499877929688 C-333.1780090332031,156.68299865722656 -353.2349853515625,232.11000061035156 -325.4309997558594,272.3399963378906 C-325.4309997558594,272.3399963378906 -325.4309997558594,272.3399963378906 -325.4309997558594,272.3399963378906 C-312.00299072265625,291.7760009765625 -288.50799560546875,301.6059875488281 -256.2900085449219,301.6059875488281 C-247.3990020751953,301.6059875488281 -237.8419952392578,300.85699462890625 -227.64700317382812,299.35101318359375"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.974183201789856,-0.11104325205087662,0.11104325205087662,0.974183201789856,521.0050048828125,521)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 3,
    d: " M-246.73199462890625,301.9630126953125 C-239.99600219726562,301.35400390625 -232.9810028076172,300.4339904785156 -225.69200134277344,299.2019958496094 C-74.35199737548828,273.625 150.30599975585938,119.06999969482422 275.093994140625,-45.34199905395508 C347.68701171875,-140.98199462890625 373.52801513671875,-221.9429931640625 345.9739990234375,-267.4440002441406 C327.2619934082031,-298.3580017089844 285.6619873046875,-309.3340148925781 225.6929931640625,-299.20098876953125 C225.6929931640625,-299.20098876953125 225.9429931640625,-297.6990051269531 225.9429931640625,-297.6990051269531 C225.9429931640625,-297.6990051269531 225.6929931640625,-299.20098876953125 225.6929931640625,-299.20098876953125 C74.35299682617188,-273.6239929199219 -150.30599975585938,-119.06900024414062 -275.093994140625,45.34299850463867 C-347.68701171875,140.98300170898438 -373.52801513671875,221.94400024414062 -345.9739990234375,267.44500732421875 C-345.9739990234375,267.44500732421875 -345.9739990234375,267.44500732421875 -345.9739990234375,267.44500732421875 C-331.7820129394531,290.8869934082031 -304.4389953613281,302.864990234375 -265.88299560546875,302.864990234375 C-259.7770080566406,302.864990234375 -253.39100646972656,302.56500244140625 -246.73199462890625,301.9630126953125"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.97723788022995,-0.10047408938407898,0.10047408938407898,0.97723788022995,521,521.0029907226562)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 3,
    d: " M-266.80999755859375,303.3760070800781 C-261.6719970703125,303.2430114746094 -256.364013671875,302.94000244140625 -250.90699768066406,302.46600341796875 C-97.89299774169922,289.11700439453125 139.38900756835938,143.03500366210938 278.03900146484375,-23.16900062561035 C359.697998046875,-121.04900360107422 392.6669921875,-209.70599365234375 366.24700927734375,-260.3059997558594 C349.1830139160156,-292.97198486328125 309.3080139160156,-307.55999755859375 250.90699768066406,-302.4599914550781 C97.89299774169922,-289.1109924316406 -139.40199279785156,-143.0290069580078 -278.03900146484375,23.174999237060547 C-359.697998046875,121.05500030517578 -392.6669921875,209.71200561523438 -366.24700927734375,260.31201171875 C-366.24700927734375,260.31201171875 -366.24700927734375,260.31201171875 -366.24700927734375,260.31201171875 C-351.40899658203125,288.72198486328125 -319.2969970703125,303.4540100097656 -272.7550048828125,303.4540100097656 C-270.79998779296875,303.4540100097656 -268.8179931640625,303.4280090332031 -266.80999755859375,303.3760070800781"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9802970886230469,-0.08940967917442322,0.08940967917442322,0.9802970886230469,520.9940185546875,521.0059814453125)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 3,
    d: " M-276.30499267578125,303.6090087890625 C-276.27899169921875,303.6090087890625 -276.25201416015625,303.6090087890625 -276.22601318359375,303.6090087890625 C-122.60600280761719,303.59600830078125 126.46900177001953,167.92300415039062 279.0480041503906,1.1130000352859497 C371.14300537109375,-99.5739974975586 411.1619873046875,-193.71099853515625 386.072998046875,-250.67599487304688 C370.8269958496094,-285.2929992675781 332.87701416015625,-303.59600830078125 276.3070068359375,-303.6090087890625 C276.281005859375,-303.6090087890625 276.2539978027344,-303.6090087890625 276.2279968261719,-303.6090087890625 C122.60800170898438,-303.6090087890625 -126.46700286865234,-167.92300415039062 -279.0459899902344,-1.1130000352859497 C-371.1549987792969,99.5739974975586 -411.1600036621094,193.71099853515625 -386.0710144042969,250.67599487304688 C-370.82501220703125,285.2929992675781 -332.875,303.59600830078125 -276.30499267578125,303.6090087890625z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9832593202590942,-0.0781768187880516,0.0781768187880516,0.9832593202590942,520.9970092773438,521.0070190429688)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 3,
    d: " M-301.72900390625,302.4490051269531 C-293.4670104980469,303.239990234375 -284.9150085449219,303.62200927734375 -276.05999755859375,303.62200927734375 C-120.89900207519531,303.6090087890625 120.3499984741211,184.73699951171875 277.9490051269531,27.506999969482422 C380.6390075683594,-74.97200012207031 428.24798583984375,-174.3280029296875 405.3059997558594,-238.26400756835938 C392.1029968261719,-275.05499267578125 356.2879943847656,-297.2449951171875 301.7340087890625,-302.45001220703125 C148.68099975585938,-317.0369873046875 -111.35800170898438,-193.71200561523438 -277.9440002441406,-27.507999420166016 C-380.6340026855469,74.97100067138672 -428.2569885253906,174.32699584960938 -405.302001953125,238.26300048828125 C-392.0979919433594,275.0539855957031 -356.2829895019531,297.2439880371094 -301.72900390625,302.4490051269531z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9860342741012573,-0.0671258345246315,0.0671258345246315,0.9860342741012573,520.9979858398438,520.9970092773438)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 3,
    d: " M-326.96600341796875,298.7820129394531 C-309.9150085449219,302.19500732421875 -291.38800048828125,303.8429870605469 -271.62200927734375,303.8429870605469 C-116.06500244140625,303.8429870605469 114.43099975585938,201.6529998779297 274.53399658203125,55.965999603271484 C387.739013671875,-47.06700134277344 443.5050048828125,-151.2449951171875 423.7130126953125,-222.7050018310547 C412.8290100097656,-261.9599914550781 379.385009765625,-288.2749938964844 326.96600341796875,-298.7770080566406 C175.75799560546875,-329.0979919433594 -94.08499908447266,-220.16200256347656 -274.53399658203125,-55.96099853515625 C-387.739013671875,47.071998596191406 -443.5050048828125,151.25100708007812 -423.7130126953125,222.71099853515625 C-412.8290100097656,261.96600341796875 -379.385009765625,288.2799987792969 -326.96600341796875,298.7820129394531z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9885551929473877,-0.05657866224646568,0.05657866224646568,0.9885551929473877,520.9990234375,521)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 3,
    d: " M-351.7919921875,292.4159851074219 C-325.59600830078125,300.7569885253906 -295.3269958496094,304.7359924316406 -262.1470031738281,304.7359924316406 C-107.88200378417969,304.7229919433594 108.9229965209961,218.74200439453125 268.6570129394531,86.45600128173828 C392.0090026855469,-15.706999778747559 456.4580078125,-124.11599731445312 441.0409851074219,-203.56100463867188 C432.8580017089844,-245.68899536132812 401.99700927734375,-276.4179992675781 351.7919921875,-292.4150085449219 C203.75900268554688,-339.57598876953125 -74.56999969482422,-247.19000244140625 -268.6570129394531,-86.45500183105469 C-392.0090026855469,15.708000183105469 -456.4580078125,124.11699676513672 -441.0409851074219,203.56199645996094 C-432.8580017089844,245.69000244140625 -401.99700927734375,276.41900634765625 -351.7919921875,292.4159851074219z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9907847046852112,-0.0467885285615921,0.0467885285615921,0.9907847046852112,520.9990234375,521)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 3,
    d: " M-375.9849853515625,283.1520080566406 C-340.56500244140625,299.2409973144531 -296.4739990234375,306.85699462890625 -247.0330047607422,306.85699462890625 C-96.35199737548828,306.85699462890625 104.00700378417969,236.13499450683594 260.1440124511719,118.91100311279297 C392.9440002441406,19.22599983215332 466.5119934082031,-92.63500213623047 456.9320068359375,-180.30299377441406 C451.95098876953125,-225.8040008544922 423.9630126953125,-261.38299560546875 375.9849853515625,-283.1650085449219 C232.59100341796875,-348.260009765625 -52.77399826049805,-274.58599853515625 -260.1440124511719,-118.92400360107422 C-392.9440002441406,-19.238000869750977 -466.5119934082031,92.62300109863281 -456.9320068359375,180.29100036621094 C-451.95098876953125,225.79200744628906 -423.9630126953125,261.3699951171875 -375.9849853515625,283.1520080566406z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9927127957344055,-0.03792281448841095,0.03792281448841095,0.9927127957344055,521,520.9949951171875)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 3,
    d: " M-399.2820129394531,270.8489990234375 C-354.9800109863281,297.9939880371094 -294.7349853515625,310.8819885253906 -225.9759979248047,310.8819885253906 C-81.75199890136719,310.8819885253906 99.73799896240234,254.13999938964844 248.83799743652344,153.2689971923828 C390.0320129394531,57.76100158691406 473.0480041503906,-56.48500061035156 470.8999938964844,-152.33599853515625 C469.7799987792969,-201.8300018310547 445.0199890136719,-242.81100463867188 399.2820129394531,-270.85198974609375 C262.08099365234375,-354.9490051269531 -28.65999984741211,-302.20098876953125 -248.83799743652344,-153.27200317382812 C-390.0320129394531,-57.763999938964844 -473.0480041503906,56.483001708984375 -470.8999938964844,152.33399963378906 C-469.7929992675781,201.8280029296875 -445.0199890136719,242.80799865722656 -399.2820129394531,270.8489990234375z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9943494200706482,-0.030067674815654755,0.030067674815654755,0.9943494200706482,521.0070190429688,520.9979858398438)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 3,
    d: " M-421.4129943847656,255.30999755859375 C-369.2439880371094,297.27899169921875 -290.260986328125,317.5190124511719 -199.33799743652344,317.5190124511719 C-64.78600311279297,317.5190124511719 95.92400360107422,273.2049865722656 234.57400512695312,189.41099548339844 C382.75201416015625,99.85900115966797 475.3479919433594,-15.442000389099121 482.2919921875,-119.01499938964844 C485.9289855957031,-173.21299743652344 464.8710021972656,-220.34800720214844 421.4129943847656,-255.3070068359375 C292.03900146484375,-359.3940124511719 -2.246999979019165,-329.822998046875 -234.57400512695312,-189.40699768066406 C-382.75201416015625,-99.8550033569336 -475.3479919433594,15.444999694824219 -482.2919921875,119.01799774169922 C-485.9289855957031,173.21600341796875 -464.8710021972656,220.3509979248047 -421.4129943847656,255.30999755859375z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9957166910171509,-0.02324509806931019,0.02324509806931019,0.9957166910171509,521,520.9949951171875)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 3,
    d: " M-442.1080017089844,236.39100646972656 C-383.7590026855469,297.2430114746094 -283.718994140625,327.4840087890625 -168.25999450683594,327.4840087890625 C-46.608001708984375,327.4840087890625 92.17400360107422,293.89599609375 217.2259979248047,227.16700744628906 C370.635009765625,145.30999755859375 472.7179870605469,30.562000274658203 490.30999755859375,-79.75700378417969 C499.8240051269531,-139.42300415039062 483.1549987792969,-193.58099365234375 442.1080017089844,-236.3939971923828 C322.2879943847656,-361.36700439453125 26.51300048828125,-357.22900390625 -217.2259979248047,-227.1699981689453 C-370.635009765625,-145.31300354003906 -472.7179870605469,-30.56599998474121 -490.30999755859375,79.75299835205078 C-499.8240051269531,139.41900634765625 -483.1549987792969,193.5780029296875 -442.1080017089844,236.39100646972656z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9968419075012207,-0.017432894557714462,0.017432894557714462,0.9968419075012207,521.0009765625,521.0050048828125)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 3,
    d: " M-461.07000732421875,213.9530029296875 C-399.0580139160156,297.7860107421875 -276.1549987792969,341.3900146484375 -134.7239990234375,341.3900146484375 C-28.700000762939453,341.3900146484375 87.73300170898438,316.8659973144531 196.64300537109375,266.4110107421875 C353.29400634765625,193.83099365234375 464.4429931640625,81.52200317382812 493.9599914550781,-34.02899932861328 C510.7869873046875,-99.88899993896484 499.4159851074219,-162.11099243164062 461.07000732421875,-213.9499969482422 C352.5820007324219,-360.6390075683594 57.53200149536133,-384.17401123046875 -196.64300537109375,-266.40899658203125 C-353.29400634765625,-193.82899475097656 -464.4429931640625,-81.51899719238281 -493.9599914550781,34.03200149536133 C-510.7869873046875,99.89199829101562 -499.4159851074219,162.11399841308594 -461.07000732421875,213.9530029296875z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9977532029151917,-0.012582137249410152,0.012582137249410152,0.9977532029151917,520.9990234375,520.9940185546875)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 3,
    d: " M-477.989990234375,187.8730010986328 C-415.6090087890625,298.5880126953125 -268.9989929199219,359.7300109863281 -101.21399688720703,359.7170104980469 C-12.70300006866455,359.7170104980469 81.71199798583984,342.7049865722656 172.71400451660156,306.9679870605469 C330.49798583984375,245.02200317382812 449.90899658203125,137.16700744628906 492.1419982910156,18.45400047302246 C517.9959716796875,-54.20500183105469 513.1069946289062,-125.55999755859375 477.989990234375,-187.875 C382.70599365234375,-356.9909973144531 90.80400085449219,-410.42401123046875 -172.71400451660156,-306.9700012207031 C-330.49798583984375,-245.0240020751953 -449.90899658203125,-137.16900634765625 -492.1419982910156,-18.45599937438965 C-517.9959716796875,54.202999114990234 -513.1069946289062,125.55799865722656 -477.989990234375,187.8730010986328z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9984771013259888,-0.008630067110061646,0.008630067110061646,0.9984771013259888,521.0020141601562,520.9990234375)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 3,
    d: " M-492.5639953613281,158.06100463867188 C-433.68798828125,299.135986328125 -263.79400634765625,382.718994140625 -70.14199829101562,382.70599365234375 C-0.052000001072883606,382.70599365234375 73.1729965209961,371.7550048828125 145.33099365234375,348.6159973144531 C302.1130065917969,298.3450012207031 428.614990234375,197.06500244140625 483.74798583984375,77.68000030517578 C520.5919799804688,-2.0820000171661377 523.635986328125,-83.60900115966797 492.5639953613281,-158.05999755859375 C412.3810119628906,-350.1969909667969 126.2249984741211,-435.6780090332031 -145.33099365234375,-348.6159973144531 C-302.1130065917969,-298.3450012207031 -428.614990234375,-197.06399536132812 -483.74798583984375,-77.67900085449219 C-520.5910034179688,2.0829999446868896 -523.635986328125,83.61000061035156 -492.5639953613281,158.06100463867188z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9990370273590088,-0.005508715752512217,0.005508715752512217,0.9990370273590088,521.0009765625,521.0070190429688)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 3,
    d: " M-504.47601318359375,124.41200256347656 C-453.41400146484375,298.8389892578125 -262.00299072265625,410.4490051269531 -43.47200012207031,410.4490051269531 C8.142999649047852,410.4490051269531 61.28799819946289,404.21600341796875 114.41799926757812,391.1180114746094 C270.4620056152344,352.65399169921875 399.2560119628906,262.3110046386719 467.7640075683594,143.2550048828125 C517.666015625,56.54899978637695 530.3560180664062,-36.00699996948242 504.47601318359375,-124.41300201416016 C441.35699462890625,-340.031005859375 163.71299743652344,-459.67999267578125 -114.43099975585938,-391.1189880371094 C-270.4620056152344,-352.6549987792969 -399.2560119628906,-262.31201171875 -467.7640075683594,-143.25599670410156 C-517.666015625,-56.54999923706055 -530.3560180664062,36.00600051879883 -504.47601318359375,124.41200256347656z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9994533061981201,-0.003150188596919179,0.003150188596919179,0.9994533061981201,521.0139770507812,520.9959716796875)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 3,
    d: " M-513.4099731445312,86.88099670410156 C-474.7090148925781,297.1099853515625 -264.7829895019531,442.8890075683594 -22.506999969482422,442.8760070800781 C11.121000289916992,442.8760070800781 45.409000396728516,440.0559997558594 79.93299865722656,434.218994140625 C231.0749969482422,408.6419982910156 363.5719909667969,328.5249938964844 443.4389953613281,214.38400268554688 C507.4800109863281,122.86799621582031 532.3319702148438,15.883000373840332 513.4099731445312,-86.87300109863281 C469.3320007324219,-326.2900085449219 203.16600036621094,-482.12298583984375 -79.91999816894531,-434.2239990234375 C-231.06199645996094,-408.6470031738281 -363.5589904785156,-328.5299987792969 -443.4259948730469,-214.38900756835938 C-507.4800109863281,-122.86000061035156 -532.3319702148438,-15.875 -513.4099731445312,86.88099670410156z"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9997427463531494,-0.0014896340435370803,0.0014896340435370803,0.9997427463531494,521.0020141601562,520.9869995117188)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 3,
    d: " M-519.0269775390625,45.42100143432617 C-497.3240051269531,293.4289855957031 -273.0090026855469,479.8340148925781 -7.922999858856201,479.8080139160156 C8.482999801635742,479.8080139160156 25.100000381469727,479.09698486328125 41.78200149536133,477.6340026855469 C180.39300537109375,465.510986328125 306.3659973144531,404.4469909667969 396.49798583984375,305.6839904785156 C486.656005859375,206.88099670410156 530.1680297851562,82.1989974975586 519.0070190429688,-45.395999908447266 C507.84600830078125,-173.00399780273438 443.35699462890625,-288.2380065917969 337.39898681640625,-369.8710021972656 C231.49400329589844,-451.4639892578125 96.822998046875,-489.7309875488281 -41.78799819946289,-477.6080017089844 C-327.9830017089844,-452.5710144042969 -542.0609741210938,-217.93800354003906 -519.0269775390625,45.42100143432617z"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9999197125434875,0,0,0.9999197125434875,521,521)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 3,
    d: " M0,519 C286.4360046386719,519 519,286.4360046386719 519,0 C519,-286.43609619140625 286.43609619140625,-519 0,-519 C0,-519 0,-519 0,-519 C-286.43609619140625,-519 -519,-286.43609619140625 -519,0 C-519,286.43609619140625 -286.43609619140625,519 0,519 C0,519 0,519 0,519"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,521,521)",
    opacity: 0.25,
    style: {
      display: "block"
    }
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(1,254,170)",
    strokeOpacity: 1,
    strokeWidth: 3,
    d: "M0 0"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,521,521)",
    opacity: 0.5,
    style: {
      display: "block"
    }
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(1,254,170)",
    strokeOpacity: 1,
    strokeWidth: 3,
    d: "M0 0"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,521,521)",
    opacity: 0.75,
    style: {
      display: "block"
    }
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(1,254,170)",
    strokeOpacity: 1,
    strokeWidth: 3,
    d: "M0 0"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,521,521)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(1,254,170)",
    strokeOpacity: 1,
    strokeWidth: 3,
    d: "M0 0"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,521,521)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 3,
    d: "M0 0"
  })))))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1042,0 L1042,1042 L0,1042z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_86"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2000,0 L2000,2000 L0,2000z"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "__lottie_element_95",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    cx: 440,
    cy: 224,
    r: 661.2110101926615,
    fx: 440,
    fy: 224
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "rgb(0,255,209)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "rgb(0,255,209)",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgb(0,255,209)",
    stopOpacity: 0
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "__lottie_element_99",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    cx: -524,
    cy: 580,
    r: 1249.857591887972,
    fx: -524,
    fy: 580
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "rgb(0,255,209)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "rgb(0,255,209)",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgb(0,255,209)",
    stopOpacity: 0
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "__lottie_element_103",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    x1: -944,
    y1: 0,
    x2: 968,
    y2: 4
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "rgb(25,200,255)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "35%",
    stopColor: "rgb(137,106,255)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "rgb(250,12,255)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85%",
    stopColor: "rgb(137,106,255)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgb(25,200,255)"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "__lottie_element_3_1",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#__lottie_element_3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "__lottie_element_104"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,600,600)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#__lottie_element_107)",
    mask: "url(#__lottie_element_109)",
    fillOpacity: 1,
    d: "M0 0 M0,-600 C331.1400146484375,-600 600,-331.1400146484375 600,0 C600,331.1400146484375 331.1400146484375,600 0,600 C-331.1400146484375,600 -600,331.1400146484375 -600,0 C-600,-331.1400146484375 -331.1400146484375,-600 0,-600z"
  }))))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "__lottie_element_107",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    cx: 0,
    cy: 0,
    r: 595.0134452262403,
    fx: 0,
    fy: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "rgb(255,255,255)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "rgb(255,255,255)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgb(255,255,255)"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "__lottie_element_109"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#__lottie_element_108)",
    d: " M0,-600 C331.1400146484375,-600 600,-331.1400146484375 600,0 C600,331.1400146484375 331.1400146484375,600 0,600 C-331.1400146484375,600 -600,331.1400146484375 -600,0 C-600,-331.1400146484375 -331.1400146484375,-600 0,-600z"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "__lottie_element_108",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    cx: 0,
    cy: 0,
    r: 595.0134452262403,
    fx: 0,
    fy: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(255,255,255)",
    offset: "50%",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(255,255,255)",
    offset: "64%",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(255,255,255)",
    offset: "78%",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(255,255,255)",
    offset: "84%",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(255,255,255)",
    offset: "90%",
    stopOpacity: 0
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_111"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2000,0 L2000,2000 L0,2000z"
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "__lottie_element_120",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    cx: 440,
    cy: 224,
    r: 661.2110101926615,
    fx: 440,
    fy: 224
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "rgb(0,255,209)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "rgb(0,255,209)",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgb(0,255,209)",
    stopOpacity: 0
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "__lottie_element_124",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    cx: -524,
    cy: 580,
    r: 1249.857591887972,
    fx: -524,
    fy: 580
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "rgb(0,255,209)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "rgb(0,255,209)",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgb(0,255,209)",
    stopOpacity: 0
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "__lottie_element_128",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    x1: -944,
    y1: 0,
    x2: 968,
    y2: 4
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "rgb(25,200,255)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "35%",
    stopColor: "rgb(137,106,255)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "rgb(250,12,255)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85%",
    stopColor: "rgb(137,106,255)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgb(25,200,255)"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "__lottie_element_104_1",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#__lottie_element_104"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "__lottie_element_129"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,600,600)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#__lottie_element_132)",
    mask: "url(#__lottie_element_134)",
    fillOpacity: 1,
    d: "M0 0 M0,-600 C331.1400146484375,-600 600,-331.1400146484375 600,0 C600,331.1400146484375 331.1400146484375,600 0,600 C-331.1400146484375,600 -600,331.1400146484375 -600,0 C-600,-331.1400146484375 -331.1400146484375,-600 0,-600z"
  }))))), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "__lottie_element_132",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    cx: 0,
    cy: 0,
    r: 595.0134452262403,
    fx: 0,
    fy: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "rgb(255,255,255)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "rgb(255,255,255)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgb(255,255,255)"
  }))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "__lottie_element_134"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#__lottie_element_133)",
    d: " M0,-600 C331.1400146484375,-600 600,-331.1400146484375 600,0 C600,331.1400146484375 331.1400146484375,600 0,600 C-331.1400146484375,600 -600,331.1400146484375 -600,0 C-600,-331.1400146484375 -331.1400146484375,-600 0,-600z"
  }))), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "__lottie_element_133",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    cx: 0,
    cy: 0,
    r: 595.0134452262403,
    fx: 0,
    fy: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(255,255,255)",
    offset: "50%",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(255,255,255)",
    offset: "64%",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(255,255,255)",
    offset: "78%",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(255,255,255)",
    offset: "84%",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(255,255,255)",
    offset: "90%",
    stopOpacity: 0
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2000,0 L2000,2000 L0,2000z"
  }))), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "__lottie_element_145",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    cx: 440,
    cy: 224,
    r: 661.2110101926615,
    fx: 440,
    fy: 224
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "rgb(0,255,209)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "rgb(0,255,209)",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgb(0,255,209)",
    stopOpacity: 0
  }))), _radialGradient0 || (_radialGradient0 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "__lottie_element_149",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    cx: -524,
    cy: 580,
    r: 1249.857591887972,
    fx: -524,
    fy: 580
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "rgb(0,255,209)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "rgb(0,255,209)",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgb(0,255,209)",
    stopOpacity: 0
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "__lottie_element_153",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    x1: -944,
    y1: 0,
    x2: 968,
    y2: 4
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "rgb(25,200,255)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "35%",
    stopColor: "rgb(137,106,255)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "rgb(250,12,255)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85%",
    stopColor: "rgb(137,106,255)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgb(25,200,255)"
  }))), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "__lottie_element_129_1",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#__lottie_element_129"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_2)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#__lottie_element_129_1)",
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_136)",
    transform: "matrix(0.699999988079071,0,0,0.699999988079071,-100,-100)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1000,1000)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#__lottie_element_153)",
    fillOpacity: 1,
    d: " M1000,-1000 C1000,-1000 1000,1000 1000,1000 C1000,1000 -1000,1000 -1000,1000 C-1000,1000 -1000,-1000 -1000,-1000 C-1000,-1000 1000,-1000 1000,-1000z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1000,1000)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#__lottie_element_149)",
    fillOpacity: 1,
    d: " M1000,-1000 C1000,-1000 1000,1000 1000,1000 C1000,1000 -1000,1000 -1000,1000 C-1000,1000 -1000,-1000 -1000,-1000 C-1000,-1000 1000,-1000 1000,-1000z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1000,1000)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#__lottie_element_145)",
    fillOpacity: 1,
    d: " M1000,-1000 C1000,-1000 1000,1000 1000,1000 C1000,1000 -1000,1000 -1000,1000 C-1000,1000 -1000,-1000 -1000,-1000 C-1000,-1000 1000,-1000 1000,-1000z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", null))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__lottie_element_104_1)",
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_111)",
    transform: "matrix(0.800000011920929,0,0,0.800000011920929,-200,-200)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1000,1000)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#__lottie_element_128)",
    fillOpacity: 1,
    d: " M1000,-1000 C1000,-1000 1000,1000 1000,1000 C1000,1000 -1000,1000 -1000,1000 C-1000,1000 -1000,-1000 -1000,-1000 C-1000,-1000 1000,-1000 1000,-1000z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1000,1000)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#__lottie_element_124)",
    fillOpacity: 1,
    d: " M1000,-1000 C1000,-1000 1000,1000 1000,1000 C1000,1000 -1000,1000 -1000,1000 C-1000,1000 -1000,-1000 -1000,-1000 C-1000,-1000 1000,-1000 1000,-1000z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1000,1000)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#__lottie_element_120)",
    fillOpacity: 1,
    d: " M1000,-1000 C1000,-1000 1000,1000 1000,1000 C1000,1000 -1000,1000 -1000,1000 C-1000,1000 -1000,-1000 -1000,-1000 C-1000,-1000 1000,-1000 1000,-1000z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", null))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__lottie_element_3_1)",
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_86)",
    transform: "matrix(0.550000011920929,0,0,0.550000011920929,50,50)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1000,1000)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#__lottie_element_103)",
    fillOpacity: 1,
    d: " M1000,-1000 C1000,-1000 1000,1000 1000,1000 C1000,1000 -1000,1000 -1000,1000 C-1000,1000 -1000,-1000 -1000,-1000 C-1000,-1000 1000,-1000 1000,-1000z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1000,1000)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#__lottie_element_99)",
    fillOpacity: 1,
    d: " M1000,-1000 C1000,-1000 1000,1000 1000,1000 C1000,1000 -1000,1000 -1000,1000 C-1000,1000 -1000,-1000 -1000,-1000 C-1000,-1000 1000,-1000 1000,-1000z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1000,1000)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#__lottie_element_95)",
    fillOpacity: 1,
    d: " M1000,-1000 C1000,-1000 1000,1000 1000,1000 C1000,1000 -1000,1000 -1000,1000 C-1000,1000 -1000,-1000 -1000,-1000 C-1000,-1000 1000,-1000 1000,-1000z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", null)))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntro);
export default __webpack_public_path__ + "static/media/intro.a4b50faca3a332c047eaa0ed105a134c.svg";
export { ForwardRef as ReactComponent };